import { useDeviceType } from '@cian/ui-kit/responsive';
import * as Cookies from 'js-cookie';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { cookiesAccepted } from '../../actions/cookies';
import { CookiesAgreementModal } from '../../components/CookiesAgreementModal';
import { CookiesNotification } from '../../components/CookiesNotification';
import { COOKIES_AGREEMENT_ACCEPTED_KEY } from '../../constants/cookies';
import { ICookiesState } from '../../types/cookies';
import { IApplicationState, TThunkDispatch } from '../../types/redux';

export const CookiesNotificationContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();
  const [isAgreementOpen, setIsAgreementOpen] = React.useState(false);
  const { accepted } = useSelector<IApplicationState, ICookiesState>(state => state.cookies);
  const noResize = useSelector<IApplicationState, boolean>(state => state.noResize);

  const normalizedDeviceType = deviceType || 'phone';
  const isBarVisible = normalizedDeviceType === 'desktop' ? !isAgreementOpen : true;

  const handleAgreementView = React.useCallback(() => {
    setIsAgreementOpen(true);
  }, []);

  const handleAgreementClose = React.useCallback(() => {
    setIsAgreementOpen(false);
  }, []);

  const handleAccept = React.useCallback(() => {
    Cookies.set(COOKIES_AGREEMENT_ACCEPTED_KEY, '1', {
      domain: '.cian.ru',
      expires: 365,
    });
    dispatch(cookiesAccepted());
  }, [dispatch]);

  if (accepted) {
    return null;
  }

  return (
    <>
      {isBarVisible && (
        <CookiesNotification noResize={noResize} onAgreementView={handleAgreementView} onAccept={handleAccept} />
      )}
      <CookiesAgreementModal
        open={isAgreementOpen}
        phone={deviceType === 'phone'}
        onAccept={handleAccept}
        onClose={handleAgreementClose}
      />
    </>
  );
};
